// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__3cSru","consentsList":"PatientConsents_consentsList__3lJBE","consentsListEmpty":"PatientConsents_consentsListEmpty__16Bxp"};